module.exports = __webpack_public_path__ + "img/tipocontacto05.34b045f.svg";